module.exports = __webpack_public_path__ + "img/USERS_SETTING.a2d48f1b.svg";